export default __webpack_public_path__ + "static/media/help_main-photo_ng2.6ee0ab79.jpg";